import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ClientDTO} from '../model/clientDTO';
import {PageClientOverviewDTO} from '../model/pageClientOverviewDTO';
import {EditClientDTO} from '../model/editClientDTO';
import {AddClientDTO} from '../model/addClientDTO';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'client';

  constructor(private http: HttpClient) {
  }

  getAll() {
    return this.http.get<Array<ClientDTO>>(this.path);
  }

  create(person: AddClientDTO) {
    return this.http.post<ClientDTO>(this.path, person);
  }

  getOne(id) {
    return this.http.get<ClientDTO>(`${this.path}/${id}`);
  }

  getOverview(pageNumber, pageSize, sortColumn, sortDirection) {
    const params = new HttpParams().append('page', pageNumber)
      .append('size', pageSize)
      .append('sort', `${sortColumn},${sortDirection}`);
    return this.http.get<PageClientOverviewDTO>(`${this.path}/overview`, {params: params});
  }

  update(clientId, editClientDto: EditClientDTO) {
    return this.http.put<ClientDTO>(`${this.path}/${clientId}`, editClientDto);
  }

  delete(id) {
    return this.http.delete<void>(`${this.path}/${id}`);
  }

  invite(email, clientId) {
    return this.http.post<void>(`${this.path}/${clientId}/invite`, {email: email});
  }

  revoke(clientId) {
    return this.http.get<void>(`${this.path}/${clientId}/revoke`);
  }

  finish(type, date: any, clientId) {
    return this.http.get<void>(`${this.path}/${clientId}/finish/${type}/${date}`);
  }

  getByAccountId(accountId: number) {
    return this.http.get<ClientDTO>(`${this.path}/account/${accountId}`);
  }
}
